
import React from 'react';
import { X } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface WelcomeOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

const WelcomeOverlay: React.FC<WelcomeOverlayProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <div className="absolute right-4 top-4">
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="Close">
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="text-center space-y-4 py-2">
          <h2 className="text-xl font-semibold text-brand-blue">Before You Begin</h2>
          
          <p className="text-gray-700">
            This is a crucial assessment to help guide your future career choices. 
            The results depend entirely on the answers you provide. Please follow these simple tips:
          </p>
          
          <ul className="space-y-2 text-left text-gray-700 mx-auto max-w-sm">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Use a desktop or laptop for best experience</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Open the test in a new browser window</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Stay focused — it takes about 20–30 minutes</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Sit in a quiet place and answer on your own</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Do not refresh the page once you've started</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>If you see "Verifying your session" or a blank screen, close the browser, reopen it, then log in again</span>
            </li>
          </ul>
          
          <p className="text-lg font-medium text-brand-blue">
            ✨ Good luck with your test!
          </p>
          
          <div className="pt-4">
            <Button onClick={onClose} className="px-8">
              Read & Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeOverlay;
